module.exports = __webpack_public_path__ + "static/images/logo-light.14b7833.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Themes/Asurion/logo-light.jpg
// module id = i52k
// module chunks = 12